var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClearButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82682 7.60938L10.8168 5.55716C11.0611 5.30532 11.0611 4.89701 10.8168 4.64497L10.3746 4.18888C10.1304 3.93704 9.73443 3.93704 9.49003 4.18888L7.5 6.24109L5.50997 4.18888C5.26577 3.93704 4.86983 3.93704 4.62543 4.18888L4.18315 4.64497C3.93895 4.89681 3.93895 5.30512 4.18315 5.55716L6.17318 7.60938L4.18315 9.66159C3.93895 9.91343 3.93895 10.3217 4.18315 10.5738L4.62543 11.0299C4.86963 11.2817 5.26577 11.2817 5.50997 11.0299L7.5 8.97766L9.49003 11.0299C9.73423 11.2817 10.1304 11.2817 10.3746 11.0299L10.8168 10.5738C11.0611 10.3219 11.0611 9.91363 10.8168 9.66159L8.82682 7.60938Z",
    fill: "#0BD6A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClearButton);
export default __webpack_public_path__ + "static/media/icon-clear-button.43d19954.svg";
export { ForwardRef as ReactComponent };